import { NflWeeklySchedule } from "../Components";

const NflWeeklySchedulePage = () => {
  return <NflWeeklySchedule />;
};

export { NflWeeklySchedulePage };
